/**
 * One subscription to "a conversation moved" (`chat` frames).
 *
 * The server says `chat` once for each conversation a folded row changed,
 * naming it (`WorkbenchService._conversations_moved`), and once for each
 * streamed chunk that moved a bubble, telling what grew or the whole bubble
 * (`WorkbenchService._chunk_loop`). `App.tsx` hands every frame here and each
 * mounted conversation decides for itself what it heard: a frame naming another
 * conversation is not its news, a telling is put on the page (`ChatPage`'s
 * `tell`), and anything else is one read of what it shows. The shell never
 * guesses which conversation is on screen. Same publish/subscribe shape as
 * `workFeed`.
 */

import type { ChatFrame } from "./api";

type Listener = (frame: ChatFrame) => void;
const listeners = new Set<Listener>();

export const chatFeed = {
  /** A `chat` frame off the stream. */
  publish(frame: ChatFrame): void {
    for (const listener of [...listeners]) listener(frame);
  },
  subscribe(listener: Listener): () => void {
    listeners.add(listener);
    return () => { listeners.delete(listener); };
  },
};
